import { render, staticRenderFns } from "./TableWithAttribute.vue?vue&type=template&id=508e566e&scoped=true"
import script from "./TableWithAttribute.vue?vue&type=script&lang=js"
export * from "./TableWithAttribute.vue?vue&type=script&lang=js"
import style0 from "./TableWithAttribute.vue?vue&type=style&index=0&id=508e566e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "508e566e",
  null
  
)

export default component.exports